import { type Commands } from '../commands';
import { UUID } from '../uuid/entity';
import { Mitigations } from './repository';
import { Mitigation } from './entity';
import { type MitigationData } from './dto';

export class MitigationsCommands
    implements Commands<Mitigations, Mitigation, MitigationData>
{
    addAll(repo: Mitigations, data: MitigationData[]): Mitigations {
        repo.clear();
        data.forEach((mitigationData) => {
            this.add(repo, mitigationData);
        });
        return repo;
    }

    add(repo: Mitigations, data: MitigationData): Mitigations {
        const mitigation = new Mitigation({
            id: data.id,
            name: data.name,
            label: data.label,
            description: data.description,
            url: data.url,
            srcId: data.srcId,
            isCustom: data.isCustom ?? false,
        });
        repo.add(mitigation);
        return repo;
    }

    update(repo: Mitigations, entity: Mitigation): Mitigation {
        repo.update(entity);
        return entity;
    }

    remove(repo: Mitigations, id: string): void {
        repo.remove(id);
    }

    create(repo: Mitigations, data: Omit<MitigationData, 'id'>): Mitigation {
        const uuid = new UUID();
        const mitigation = new Mitigation({
            id: uuid.toString(),
            name: data.name,
            label: data.label,
            description: data.description,
            url: data.url,
            srcId: data.srcId,
            isCustom: data.isCustom ?? false,
        });
        repo.add(mitigation);
        return mitigation;
    }

    fromJSON(entity: Mitigation[], changeCallback: () => void): Mitigations {
        const newMitigations = new Mitigations(changeCallback);
        entity.forEach((mitigation) => {
            newMitigations.add(
                new Mitigation({
                    id: mitigation.id,
                    name: mitigation.name,
                    label: mitigation.label,
                    description: mitigation.description,
                    url: mitigation.url,
                    srcId: mitigation.srcId,
                    isCustom: mitigation.isCustom ?? false,
                }),
            );
        });
        return newMitigations;
    }
}
